<template>
  <div class="my-card-block" :class="className" @click="cardClick">
    <div class="card-icon">
      <img :src="item.icon" class="icon" />
    </div>
    <div class="card-name">{{ item.name }}</div>
  </div>
</template>

<script>
export default {
  name: "pi-card-block",
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    className: {
      type: String,
      default: "",
    },
  },
  methods: {
    cardClick() {
      this.$emit("click", this.item);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.my-card-block {
  padding: 0.2rem 0 0.3rem 0;
  text-align: center;
  margin: auto;
}
.my-card-block.pd30 {
  padding: 0.3rem 0 0.3rem 0;
}
.my-card-block .card-icon {
  width: 0.6rem;
  height: 0.6rem;
  margin: auto;
}
.my-card-block .card-icon .icon {
  width: 100%;
  height: 100%;
}
.my-card-block .card-name {
  margin-top: 0.05rem;
  color: #333;
  font-size: 0.2rem;
  line-height: 0.28rem;
}
</style>
